import { Component, OnInit } from '@angular/core';
import { DateUtilService, GungNotificationService } from 'gung-common';
import { first } from 'rxjs';
import { GungModalService } from '../../services/gung-modal/gung-modal.service';
import { MfaService } from '../../services/mfa/mfa.service';
import { UsersService } from '../../services/users/users.service';
import { User } from '../../state/auth/types';

@Component({
  selector: 'lib-my-account',
  templateUrl: './my-account.component.html',
  styleUrl: './my-account.component.scss',
  standalone: false
})
export class MyAccountComponent implements OnInit {
  currentUser: User;

  constructor(
    protected usersService: UsersService,
    protected mfaService: MfaService,
    protected gungModalService: GungModalService,
    protected gungNotificationService: GungNotificationService,
    protected dateUtilService: DateUtilService
  ) {}

  ngOnInit(): void {
    this.getUser();
  }

  getUser(): void {
    this.usersService
      .getCurrentUsers()
      .pipe(first())
      .subscribe(user => (this.currentUser = user));
  }

  deleteMfaDevice(id: string): void {
    this.gungModalService.openConfirmYesNoModal('DELETE_MFA', 'DELETE_MFA_CONFIRMATION_TEXT').then(
      result => {
        if (result === true) {
          this.mfaService.deleteSetup(id).subscribe(_ => {
            this.gungNotificationService.notify('SUCCESS', 'MFA_DELETED', 'success');
            this.getUser();
          });
        }
      },
      reject => {}
    );
  }

  addMfaDevice(): void {
    this.gungModalService.openAddUserMfa().then(_ => {
      this.getUser();
    });
  }
}
